"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
var companySwitcherStyle = {
    option: function (provided, state) { return (__assign(__assign({}, provided), { backgroundColor: null, color: state.isSelected ? '#151C23' : '#757575', fontWeight: state.isSelected ? '500' : 'normal', fontSize: '1.3rem', lineHeight: '3.2rem', padding: '0px 16px', cursor: 'pointer', '&:hover': {
            backgroundColor: '#F3F4F5',
            color: '#151C23'
        } })); },
    menu: function (provided, _state) { return (__assign(__assign({}, provided), { marginTop: '0px', borderRadius: 0, cursor: 'pointer', boxShadow: '0px 8px 16px rgba(0,0,0,.16)', borderTop: '1px solid #D6D8DC' })); },
    control: function (provided, _state) { return (__assign(__assign({}, provided), { borderRadius: 0, borderWidth: 0, boxShadow: 'none', borderTop: '1px solid #D6D8DC', '&:hover': {
            borderTop: '1px solid #D6D8DC'
        } })); },
    input: function (provided) { return (__assign(__assign({}, provided), { marginLeft: '48px', marginBottom: '0px', '&:focus': {
            boxShadow: 'none'
        } })); },
    valueContainer: function (provided) { return (__assign(__assign({}, provided), { height: '48px', padding: '0px', margin: '0px' })); },
    placeholder: function (provided) { return (__assign(__assign({}, provided), { marginLeft: '0px', marginRight: '0px', marginTop: '2px' })); },
    indicatorsContainer: function () { return ({ display: 'none' }); }
};
exports["default"] = companySwitcherStyle;
